import React, {useEffect, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {FormGroup} from "@blueprintjs/core"
import Props from "../../../core/components/props"
import "./FilterOptionPanel.scss"
import Filter, {MatchMode} from "../../models/filter"
import StringSelect from "../../../core/components/StringSelect"
import {
    loadValuesAction,
    loadVariablesAction,
    setMultipleContextAction,
} from "../../redux/refdb.actions"
import {
    getMultiContext,
    valuesSelector,
    variablesSelector,
} from "../../redux/refdb.selector"
import FilterTypeSelect from "./FilterTypeSelect"
import {FilterType} from "../../../shared/enums/filterType"
import MinimalButton from "../../../core/components/buttons/MinimalButton"
import {RefDbDataContext} from "../../models/displayDataContext"
import DoubleInput from "./DoubleInput"
import DoubleDateInput from "./DoubleDateInput"
import {SingleSelectString} from "../../../core/components/SingleSelectString"

export interface StringSelectProps extends Props {
    selectedValue?: string
    values?: string[]
    setSelectedValue?: (value: string) => void
    disabled?: boolean
    open: boolean
    subset: number
}

const FilterOptionPanelInternal: React.FC<StringSelectProps> = (props) => {
    const {open} = props
    const variables = useSelector(variablesSelector)
    const values = useSelector(valuesSelector)

    const dispatch = useDispatch()

    const contextData = useSelector(getMultiContext)
    const initialValue = contextData[props.subset]
    const [context, setContext] = useState<RefDbDataContext>(initialValue)
    useEffect(() => {
        console.log("Dispatch context to redux...")
        const {filters} = context
        dispatch(
            setMultipleContextAction({...contextData[props.subset], filters})
        )
    }, [context])

    function setFilters(filters: any[]) {
        setContext({
            ...context,
            filters,
        })
    }

    // handle click event of the Remove button
    const handleRemoveClick = (index: number) => {
        const list = [...context.filters]
        list.splice(index, 1)
        setFilters(list)
    }

    const updateFilter = (index: number, value: string) => {
        const list = [...context.filters]
        list[index].name = value
        setFilters(list)
        dispatch(loadValuesAction(value))
    }

    const updateFilterValue = (index: number, value: any) => {
        const list = [...context.filters]
        list[index].value = value
        setFilters(list)
    }

    const updateFilterValueFrom = (index: number, value: any) => {
        const list = [...context.filters]
        list[index].from = value
        setFilters(list)
    }

    const updateFilterValueTo = (index: number, value: any) => {
        const list = [...context.filters]
        list[index].to = value
        setFilters(list)
    }

    const updateFilterType = (index: number, value: any) => {
        const list = [...context.filters]
        list[index].filterType = value
        if (list[index].filterType === FilterType.numerical) {
            list[index].matchMode = MatchMode.between
        } else if (list[index].filterType === FilterType.date) {
            list[index].matchMode = MatchMode.dateBetween
        } else {
            list[index].matchMode = MatchMode.equals
        }
        setFilters(list)
    }

    useEffect(() => {
        dispatch(loadVariablesAction(true))
    }, [])

    const handleAddClick = () => {
        setFilters([...context.filters, Filter.enabled()])
    }

    return (
        <div style={{marginLeft: "17px"}}>
            {open && (
                <div>
                    {context.filters.map((x, i) => {
                        return (
                            <div className="DisplayDataConfigBarContainer">
                                <div className="FilterOptionPanel">
                                    <FormGroup
                                        className="CardRowElement"
                                        inline
                                        label="Select variable"
                                        labelFor="sample-source-select"
                                    >
                                        <SingleSelectString
                                            name="sample-source-select"
                                            className="CardRowElement2"
                                            items={variables || []}
                                            selected={context.filters[i].name}
                                            handleSelect={(value) =>
                                                updateFilter(i, value.selected)
                                            }
                                            disabled={false}
                                        />
                                    </FormGroup>
                                    <FormGroup
                                        className="CardRowElement"
                                        inline
                                        label="Filter type"
                                        labelFor="variable"
                                    >
                                        <FilterTypeSelect
                                            selectedValue={
                                                context.filters[i].filterType
                                            }
                                            setSelectedValue={(value) =>
                                                updateFilterType(i, value)
                                            }
                                            className=""
                                            id="filter-type-select"
                                        />
                                    </FormGroup>
                                    {context.filters[i].filterType ===
                                        FilterType.numerical && (
                                        <DoubleInput
                                            valueFrom={context.filters[i].from}
                                            setValueFrom={(value) => {
                                                updateFilterValueFrom(i, value)
                                            }}
                                            valueTo={context.filters[i].to}
                                            setValueTo={(value) => {
                                                updateFilterValueTo(i, value)
                                            }}
                                        />
                                    )}
                                    {context.filters[i].filterType ===
                                        FilterType.date && (
                                        <DoubleDateInput
                                            valueFrom={context.filters[i].from}
                                            setValueFrom={(value) => {
                                                updateFilterValueFrom(i, value)
                                            }}
                                            valueTo={context.filters[i].to}
                                            setValueTo={(value) => {
                                                updateFilterValueTo(i, value)
                                            }}
                                        />
                                    )}
                                    {context.filters[i].filterType ===
                                        FilterType.category && (
                                        <StringSelect
                                            selectedValue={
                                                context.filters[i].value
                                            }
                                            values={
                                                values[
                                                    context.filters[i].name
                                                ] || []
                                            }
                                            setSelectedValue={(value) => {
                                                updateFilterValue(i, value)
                                            }}
                                        />
                                    )}
                                    <MinimalButton
                                        text="Remove filter"
                                        onClick={() => handleRemoveClick(i)}
                                    />
                                </div>
                            </div>
                        )
                    })}
                    {context.filters.length < 10 && (
                        <MinimalButton
                            text="Add filter"
                            onClick={handleAddClick}
                        />
                    )}
                </div>
            )}
        </div>
    )
}

FilterOptionPanelInternal.defaultProps = {
    disabled: false,
}

export default FilterOptionPanelInternal
